import {
  Shield,
  ArrowRight,
  Lock,
  Server,
  HardDrive,
  Globe,
  CheckCircle2,
  Scan,
  Tag,
  Truck,
  Warehouse,
  ListChecks,
  Box,
  CloudCog,
} from "lucide-react";
import { useState } from "react";
import inventry from "../../images/inventry.png";
import data from "../../images/data_manage.webp";
import { GrDocumentConfig } from "react-icons/gr";
import { FaRegLightbulb } from "react-icons/fa";
import { VscDebugDisconnect } from "react-icons/vsc";
import { AiOutlineAudit } from "react-icons/ai";
import { TfiEmail } from "react-icons/tfi";
import { TbDatabaseEdit, TbReportAnalytics } from "react-icons/tb";
import { CiMobile1 } from "react-icons/ci";

const InventoryTracking = () => {
  const features = [
    {
      icon: Scan,
      title: "Real-Time Stock Scanning",
      description:
        "Use mobile scanners to track inventory items in and out of stock, ensuring a perpetually accurate count of physical goods and components.",
    },
    {
      icon: HardDrive,
      title: "Comprehensive Item Details",
      description:
        "Log detailed information for every item, including serial numbers, batch/lot tracking, SKU, dimensions, and shelf-life where applicable.",
    },
    {
      icon: Warehouse,
      title: "Multi-Location and Bin Tracking",
      description:
        "Manage inventory across multiple warehouses, stockrooms, and physical bin locations, providing precise knowledge of where every item is stored.",
    },
    {
      icon: Box,
      title: "Stock Level Alerts",
      description:
        "Configure automated alerts for minimum stock levels (reorder points) and maximum stock levels to prevent stockouts and overstocking.",
    },
    {
      icon: TbReportAnalytics,
      title: "In-Depth Stock Reporting",
      description:
        "Generate reports on current stock levels, inventory valuation, movement history, and item consumption rates for optimized planning.",
    },
    {
      icon: Truck,
      title: "Item Movement & Transfers",
      description:
        "Easily log and track the transfer of items between different storage locations or departments with a complete history log.",
    },
  ];

  const values = [
    {
      icon: Server,
      title: "Accurate Stock Levels",
      description:
        "Maintain a 100% accurate count of all items, reducing costly discrepancies and the need for frequent physical counts.",
    },
    {
      icon: Server,
      title: "Reduced Carrying Costs",
      description:
        "Prevent excess inventory by optimizing stock levels based on consumption data and minimizing storage and obsolescence costs.",
    },
    {
      icon: Shield,
      title: "Streamlined Logistics",
      description:
        "Improve efficiency in receiving, picking, and shipping by having immediate, accurate location data for every stock item.",
    },
    {
      icon: FaRegLightbulb,
      title: "Optimized Reordering", // Changed icon to FaRegLightbulb (from the imports)
      description:
        "Automated reorder point alerts ensure materials are ordered just in time to meet demand without excessive lead time or rush fees.",
    },
    {
      icon: CheckCircle2,
      title: "Faster Audits & Cycle Counts",
      description:
        "Quickly verify stock accuracy with dedicated tools for cycle counting and generating audit trails for all inventory transactions.",
    },
    {
      icon: VscDebugDisconnect,
      title: "Clear Usage Tracking", // Changed icon to VscDebugDisconnect (from the imports)
      description:
        "Monitor exactly when and by whom inventory items are consumed or allocated, providing valuable insights into operational flow.",
    },
  ];

  const [loading, setLoading] = useState(false);
  const [contactForm, setContactForm] = useState(false);
  const [demoFormData, setDemoFormData] = useState({
    fullname: "",
    email: "",
    phone: "",
    textarea: "",
    organization: "",
    agree: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [demoMessage, setDemoMessage] = useState("");
  const [demoErrors, setDemoErrors] = useState("");
  const [trialMessage, setTrialMessage] = useState("");
  const [trialErrors, setTrialErrors] = useState("");

  const handleDemoChange = (e) => {
    const { name, type, value, checked } = e.target;
    setDemoFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTrial = async (e) => {
    setLoading(true);
    e.preventDefault();
    const payload = {
      name: demoFormData.fullname,
      email: demoFormData.email,
      subject: "Request for Inventory Management Product Free Trail ",
      phone: demoFormData.phone,
      organization: demoFormData.organization,
      message: demoFormData.textarea,
    };

    console.log(payload);
    try {
      const response = await fetch(
        `https://backend.maplecloudtechnologies.com:7443/support`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok) {
        setLoading(false);
        alert("✅" + data.message);
        setDemoFormData(false);
        setDemoFormData({
          fullname: "",
          email: "",
          phone: "",
          textarea: "",
          organization: "",
          agree: false,
        });
      } else {
        setLoading(false);
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
      setLoading(false);
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };
  const handleDemoSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: demoFormData.fullname,
      email: demoFormData.email,
      subject: "Request for Inventory Management Product Demo",
      phone: demoFormData.phone,
      message: demoFormData.textarea,
    };

    try {
      const response = await fetch(
        `https://maplecloudtechnologies.com/support`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok) {
        alert("✅ " + data.message);
        setContactForm(false);
        setDemoFormData({
          fullname: "",
          email: "",

          textarea: "",
          agree: false,
        });
      } else {
        alert("❌ " + (data.error || "Failed to submit support request."));
      }
    } catch (err) {
      console.error("Error:", err);
      alert("⚠️ Something went wrong. Please try again.");
    }
  };

  const [trialForm, setTrialForm] = useState(false);
  const [users, setUsers] = useState("");
  return (
    <>
      {trialForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a free trial{" "}
            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a free trial.
            </p>
            <form onSubmit={handleTrial} className="space-y-5">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={demoFormData.fullname}
                  onChange={handleDemoChange}
                  placeholder="Your full name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={demoFormData.email}
                  onChange={handleDemoChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={demoFormData.phone}
                  onChange={handleDemoChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={demoFormData.textarea || ""}
                    onChange={handleDemoChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setTrialForm(false);
                    setDemoFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-cyan-700 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-cyan-600 text-white py-2 rounded-lg font-semibold hover:bg-cyan-700 transition"
                >
                  Request Trial
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {contactForm && (
        <div className="flex fixed w-full  items-center justify-center min-h-screen bg-gray-900/80 backdrop-blur-sm z-20 p-4">
          <div className="w-full max-w-md bg-slate-950 text-white p-8 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-2xl font-medium mb-6">
              Contact Us for a Product Demo
            </h1>
            <p className="text-gray-400 text-sm mb-6">
              Fill out the form below and our team will get in touch with you
              for a personalized demo.
            </p>
            <form onSubmit={handleDemoSubmit} className="space-y-5">
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={demoFormData.fullname}
                  onChange={handleDemoChange}
                  placeholder=" full name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={demoFormData.email}
                  onChange={handleDemoChange}
                  placeholder="Your email"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="organization"
                  name="organization"
                  type="text"
                  value={demoFormData.phone}
                  onChange={handleDemoChange}
                  placeholder="Organization Name"
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={demoFormData.phone}
                  onChange={handleDemoChange}
                  placeholder="Tel."
                  required
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={demoFormData.textarea || ""}
                    onChange={handleDemoChange}
                    placeholder="Message..."
                    required
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              <div className="w-full flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setContactForm(false);
                    setDemoFormData({
                      fullname: "",
                      email: "",
                      phone: "",
                      password: "",
                      textarea: "",
                      company: "",
                      agree: false,
                    });
                  }}
                  className="w-full bg-slate-600 text-white py-2 rounded-lg font-semibold hover:bg-cyan-700 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full bg-cyan-600 text-white py-2 rounded-lg font-semibold hover:bg-cyan-700 transition"
                >
                  Request Demo
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Hero Section (Color scheme changed to Blue/Cyan) */}
      <section className="relative overflow-hidden pt-20 pb-10 px-4 sm:px-6 lg:px-8">
        {/* Background Effects */}
        <div className="absolute inset-0 bg-gradient-to-b from-cyan-600/10 to-transparent"></div>
        <div className="absolute top-20 left-10 w-56 sm:w-72 h-56 sm:h-72 bg-cyan-600/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-5 w-64 sm:w-96 h-64 sm:h-96 bg-cyan-600/20 rounded-full blur-3xl"></div>

        {/* Main Container */}
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-12 px-4 sm:px-8 mt-5">
          {/* Left Content */}
          <div className="text-start w-full lg:w-1/2 mt-5">
            <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-6">
              <Warehouse className="w-4 h-4 text-cyan-400" />
              <span className="text-sm text-cyan-300 font-medium">
                INVENTORY MANAGEMENT
              </span>
            </div>

            <h1 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight">
              <span className="block uppercase text-3xl sm:text-5xl bg-gradient-to-r from-cyan-400 to-cyan-700 bg-clip-text text-transparent mb-2">
                Real-Time Inventory Tracking System
              </span>
              Master Your Stock: Know What You Have and Where It Is
            </h1>

            <p className="text-md sm:text-lg text-slate-300 mb-10 leading-relaxed">
              Our platform delivers accurate, real-time tracking of all your
              physical and digital stock, ensuring precise quantity counts,
              multi-location awareness, and automated reorder management. Stop
              guessing—start knowing your inventory status instantly.
            </p>
          </div>

          {/* Right Side Form */}
          <div className="w-full lg:w-1/2 max-w-md bg-slate-900/40 backdrop-blur-md text-white p-6 sm:p-6 border border-gray-800 rounded-2xl shadow-xl">
            <h1 className="text-xl sm:text-2xl font-medium mb-4 text-center lg:text-left">
              Contact for free trial
            </h1>

            <form
              onSubmit={(e) => {
                handleTrial(e);
                setUsers("");
              }}
              className="space-y-3"
            >
              <div>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  value={demoFormData.fullname}
                  onChange={handleDemoChange}
                  placeholder="Your name"
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={demoFormData.email}
                  onChange={handleDemoChange}
                  placeholder="Your email"
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="organization"
                  name="organization"
                  type="text"
                  value={demoFormData.organization}
                  onChange={handleDemoChange}
                  placeholder="Organization name"
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>
              <div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={demoFormData.phone}
                  onChange={handleDemoChange}
                  placeholder="Tel."
                  className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg focus:ring focus:ring-indigo-300"
                />
              </div>

              <div>
                <div className="relative">
                  <textarea
                    id="textarea"
                    name="textarea"
                    value={demoFormData.textarea || ""}
                    onChange={handleDemoChange}
                    placeholder="Message..."
                    className="w-full px-3 py-2 border bg-slate-800 border-slate-700 rounded-lg"
                  />
                </div>
              </div>

              {/* Checkbox */}
              <div className="flex items-start gap-2 text-sm">
                <input
                  id="agree"
                  name="agree"
                  type="checkbox"
                  checked={demoFormData.agree}
                  onChange={handleDemoChange}
                  className="mt-1"
                />
                <label htmlFor="agree" className="text-gray-400">
                  I agree to the{" "}
                  <a href="#" className="text-cyan-400 hover:underline">
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a href="#" className="text-cyan-400 hover:underline">
                    Privacy Policy
                  </a>
                  .
                </label>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-cyan-600 text-white py-2 rounded-lg font-semibold hover:bg-cyan-700 transition"
              >
                {loading ? "Sending..." : " Send Request"}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Features Section (Content changed to Inventory focus) */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-6">
              <Globe className="w-4 h-4 text-cyan-400" />
              <span className="text-md text-cyan-300 font-medium">
                Core Capabilities
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Essential Inventory Tracking Features
            </h2>
            <p className="text-sm text-slate-400 max-w-3xl mx-auto">
              Our solution focuses purely on the fundamentals: maintaining
              accurate stock counts, knowing item locations, and automating
              reordering processes to keep your operations running smoothly.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f, index) => (
              <div
                key={index}
                className="bg-slate-900 border border-slate-700 rounded-xl p-8 hover:border-blue-500/50 transition hover:shadow-3xl hover:shadow-blue-500/10 group"
              >
                <div className="bg-gradient-to-br from-cyan-500 to-cyan-800 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <f.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  {f.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-xs">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Modules Section */}
      <section
        id="modules"
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col items-center"
      >
        {/* Section Header */}
        <div className="w-[90%] max-w-[450px] flex justify-center text-lg items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-10">
          <Warehouse className="w-6 h-6 text-cyan-400" />
          <span className="text-xl text-cyan-300 font-medium">
            CORE INVENTORY MODULES
          </span>
        </div>

        {/* Content */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start w-full">
          {/* Image */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src={inventry}
              alt="inventory_img"
              className="w-full max-w-md object-contain"
            />
          </div>

          {/* Features List */}
          <div className="w-full lg:w-1/2 mt-6 lg:mt-0">
            <div className="space-y-6">
              {[
                "MOBILE SCANNING : Use barcodes and QR codes with mobile devices for fast and error-free receiving, picking, and transfers.",
                "STOCK VALUATION : Calculate current inventory value using methods like FIFO, LIFO, or Average Cost for accurate accounting and reporting.",
                "MIN/MAX LEVELS : Automatically determine and manage optimal reorder points to maintain fluid stock flow and prevent excess or shortage.",
                "USAGE TRACKING : Log all item consumption and allocation to projects or departments to accurately track expenditure and demand.",
                "VENDOR & PO LINKING : Easily connect stock receipts and cost data directly to purchase orders and supplier records.",
              ].map((text, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-cyan-600/20 rounded-full flex items-center justify-center text-cyan-400">
                    <CheckCircle2 className="w-5 h-5" />
                  </div>
                  <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
                    {text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Business Value Section (Content changed to Inventory focus) */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Operational Benefits of Accurate Inventory
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.map((f, index) => (
              <div
                key={index}
                className="bg-slate-900 border border-slate-700 rounded-xl p-8 hover:border-blue-500/50 transition hover:shadow-3xl hover:shadow-blue-500/10 group"
              >
                <div className="bg-gradient-to-br from-cyan-500 to-cyan-800 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <f.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  {f.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-xs">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white py-24 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-cyan-600">
              Pricing Plans
            </span>
          </h2>
          <p className="text-slate-400 mb-16 max-w-2xl mx-auto text-lg">
            Transparent and flexible pricing tailored for individuals, startups,
            and enterprises. Upgrade as your business grows.
          </p>

          <div className="grid  md:grid-cols-3">
            <div className="bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-xl border border-slate-700 p-10  hover:shadow-cyan-500/20 transition duration-300">
              <h3 className="text-2xl font-semibold mb-3">Plan 1</h3>
              <div className="text-3xl font-bold mt-6 text-cyan-400">
                50
                <span className="text-2xl text-slate-200"> Devices</span>
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => {
                  }}
                  className="w-full bg-white text-cyan-700 font-semibold py-3 rounded-xl shadow-md hover:bg-slate-100 transition"
                >
                  Start Trial
                </button>
                <button
                  onClick={() => {
                    setTrialForm(true);
                    setUsers(" for 50 Devices");
                  }}
                  className="w-full bg-cyan-600 hover:bg-cyan-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-cyan-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>

          <div className="relative z-10 scale-110 bg-gradient-to-b from-slate-600 to-cyan-950 rounded-3xl shadow-2xl p-10  transition duration-300 border border-slate-700">
              <h3 className="text-2xl font-semibold mb-3">Plan 2</h3>
              <div className="text-xl mt-6 font-medium  text-white">
                Contact us for purchase
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => setContactForm(true)}
                  className="w-full bg-cyan-600 hover:bg-cyan-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-cyan-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>

            <div className="bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-xl border border-slate-700 p-10  hover:shadow-cyan-500/20 transition duration-300">
              <h3 className="text-2xl font-semibold mb-3">Plan 3</h3>
              <div className="text-3xl font-bold mt-6 text-cyan-400">
                250
                <span className="text-2xl text-slate-200"> Device</span>
              </div>

              <div className="flex items-center gap-5 my-20">
                <button
                  onClick={() => {
                  }}
                  className="w-full bg-white text-cyan-700 font-semibold py-3 rounded-xl shadow-md hover:bg-slate-100 transition"
                >
                  Start Trial
                </button>
                <button
                  onClick={() => {
                    setTrialForm(true);
                    setUsers(" for 250 Devices");
                  }}
                  className="w-full bg-cyan-600 hover:bg-cyan-500 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-cyan-500/40 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default InventoryTracking;
